import { Component, Input, Inject, Optional, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TypeaheadService } from '@app/services/typeahead.service';
import { Item } from '@app/core/components/listbox/listbox.component';
import { GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { Grid } from '@app/core/components/grid/grid.model';
import { ModalService } from '@app/core/services/modal.service';
import { RowSelectedEvent } from '@ag-grid-community/core';
import { OrderlineCalcFormService, CalcCopyFromParams, CalcCopyFromGet } from '../orderline-calc-form/orderline-calc-form.service';

@GridModalComponent('calccopyfrom')
@Component({
    selector: 'tt-calc-copy-from',
    templateUrl: './calc-copy-from.component.html',
    styleUrls: ['./calc-copy-from.component.css'],
})
export class CalcCopyFromComponent implements OnChanges {
    @Input()
    public params?: CalcCopyFromParams;

    public get?: CalcCopyFromGet;

    @Output()
    public submit = new EventEmitter<ErrorMessageResponse>();

    public grid?: GridOptions;

    public saving = false;

    constructor(
        private typeahead: TypeaheadService,
        private modal: ModalService,
        private orderlineCalcForm: OrderlineCalcFormService,
        @Inject(TT_STATE_DIALOG) @Optional() stateDialog: StateDialogContext,
    ) {
        this.initFromDialog(stateDialog);
    }

    public searchCustomer = () => {
        return this.typeahead.searchCustomer({ cust_name: this.get?.cust_name ?? '', custtype: 'C', lastselect: 'SEARCH' });
    };

    public onCustomerSelected(event?: Item) {
        if (!this.get) return;

        this.get.cust_no = !!event ? '' + event.item_id : '0';
        this.get.cust_name = event?.item_name ?? '';

        this.grid?.gridfunc?.read();
    }

    public onRowSelected(_: RowSelectedEvent) {
        if (!this.get) return;

        this.get.calc_keyno_copy_from = this.grid?.gridfunc?.getSelectedRows()?.[0]?.['calc_keyno'] ?? '0';
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.orderlineCalcForm.getCalcCopyFrom(this.params);
        }
    }

    private readGrid() {
        if (!this.grid) {
            this.createGrid();
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private createGrid() {
        if (!this.get) return;
        this.grid = new Grid().setRememberId('w_calccopyfrom.grid').setLoadDataFunction({ method: 3896, parameters: () => this.get });
    }

    public async copyFromSelectedRow() {
        if (!this.get) return;

        this.saving = true;

        try {
            const { errorcode, errormessage } = await this.orderlineCalcForm.saveCalcCopyFrom(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.submit.emit({ errorcode, errormessage });
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    private async init() {
        await this.loadGet();
        this.readGrid();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }

    private async initFromDialog(stateDialog?: StateDialogContext) {
        if (!!stateDialog?.params && 'calc_keyno' in stateDialog.params) {
            stateDialog.dialogRef.disableClose = true;
            this.params = stateDialog.params as unknown as CalcCopyFromParams;
            stateDialog.setSize({ height: '100vh', width: '100vw' });
            await this.init();
            // stateDialog.setHeading(this.get?.webpage_heading ?? '');
            this.submit.subscribe({ next: (value: ErrorMessageResponse) => stateDialog.close(value) });
        }
    }
}
